import type { SystemStyleObject } from '@chakra-ui/react/styled-system'
import { Button } from '@web/components/atoms/Button'
import { useBrandingsStore } from '@web/components/utils/branding/useBrandingsStore'
import { forwardRef, Ref } from 'react'

export type PageRadioButtonStyles = {
  width?: string
  unselectedColor?: string
  selectedColor?: string
  borderColor?: string
  selectedTextColor?: string
  unselectedTextColor?: string
}

type PageRadioButtonProps = {
  id?: string
  isActive: boolean
  onClick: () => void
  buttonText: string
  isError?: boolean
  icon?: React.ReactNode
  styles?: PageRadioButtonStyles
  css?: SystemStyleObject
}

const PageRadioButton = forwardRef<HTMLButtonElement, PageRadioButtonProps>(
  (props: PageRadioButtonProps, ref: Ref<HTMLButtonElement>) => {
    const { id, isActive, onClick, buttonText, isError, styles, css, icon, ...rest } = props
    const {
      width,
      unselectedColor,
      selectedColor,
      borderColor,
      selectedTextColor,
      unselectedTextColor = 'ge.text.primary',
    } = styles ?? {}
    const { colorData } = useBrandingsStore(({ colorData, buttonData }) => ({ colorData, buttonData }))

    return (
      <Button
        {...rest}
        id={id}
        ref={ref}
        className="group"
        variant="solid"
        border="2px solid transparent"
        borderColor={isError ? 'ge.text.danger' : 'transparent'}
        bgColor={unselectedColor ?? '#FFFFFF'}
        buttonAppearance="unstyled"
        {...(isActive ? { 'aria-pressed': true, 'data-active': true } : {})}
        onClick={onClick}
        color={unselectedTextColor}
        css={{
          ...css,
          '&:active, &[data-active]': {
            bgColor: selectedColor || colorData['Brand'],
            color: selectedTextColor ?? 'ge.white',
          },
        }}
        height="50px"
        fontSize="20px"
        _hover={{
          borderColor: borderColor ?? selectedColor ?? colorData['Brand'],
        }}
        width={width}
      >
        {icon}
        {buttonText}
      </Button>
    )
  },
)

export default PageRadioButton
